import React, { useEffect, useState } from "react";
import {
        Modal,
        ModalOverlay,
        ModalContent,
        ModalHeader,
        ModalCloseButton,
        ModalBody,
        ModalFooter,
        Button,
        Text,
        VStack,
        Input,
        Flex,
} from "@chakra-ui/react";

const FileManagerModal = ({
        isOpen,
        onClose,
        title,
        description,
        hasFile,
        onUpload,
        onView,
        onDelete,
        isUploading,
        isDeleting,
        accept = "image/*,application/pdf",
        uploadLabel = "Subir archivo",
        viewLabel = "Ver archivo",
        deleteLabel = "Eliminar archivo",
        allowUpload = true,
        allowDelete = true,
}) => {
        const [selectedFile, setSelectedFile] = useState(null);

        useEffect(() => {
                if (!isOpen) {
                        setSelectedFile(null);
                }
        }, [isOpen]);

        const handleFileChange = (event) => {
                const file = event?.target?.files?.[0];
                if (file) {
                        setSelectedFile(file);
                }
        };

        const handleUpload = () => {
                if (selectedFile && onUpload) {
                        onUpload(selectedFile);
                }
        };

        return (
                <Modal isOpen={isOpen} onClose={onClose} isCentered>
                        <ModalOverlay />
                        <ModalContent mx={4}>
                                <ModalHeader>{title}</ModalHeader>
                                <ModalCloseButton />
                                <ModalBody>
                                        <VStack alignItems="flex-start" spacing={4}>
                                                {description && <Text>{description}</Text>}
                                                <Flex direction="column" w="100%" gap={2}>
                                                        <Text fontSize="sm" fontWeight={600}>
                                                                Selecciona un archivo (PDF o imagen)
                                                        </Text>
                                                        <Input
                                                                type="file"
                                                                onChange={handleFileChange}
                                                                accept={accept}
                                                                isDisabled={!allowUpload}
                                                        />
                                                        {selectedFile && (
                                                                <Text fontSize="sm" color="gray.600">
                                                                        Archivo seleccionado: {selectedFile.name}
                                                                </Text>
                                                        )}
                                                </Flex>
                                                {hasFile && (
                                                        <Flex direction="column" gap={2} w="100%">
                                                                <Button onClick={onView} colorScheme="blue" variant="outline">
                                                                        {viewLabel}
                                                                </Button>
                                                                {allowDelete && (
                                                                        <Button
                                                                                onClick={onDelete}
                                                                                colorScheme="red"
                                                                                isLoading={isDeleting}
                                                                        >
                                                                                {deleteLabel}
                                                                        </Button>
                                                                )}
                                                        </Flex>
                                                )}
                                        </VStack>
                                </ModalBody>
                                <ModalFooter>
                                        <Flex gap={2} w="100%" justify="flex-end">
                                                <Button variant="ghost" onClick={onClose}>
                                                        Cancelar
                                                </Button>
                                                {!hasFile && allowUpload && (
                                                        <Button
                                                                colorScheme="yellow"
                                                                onClick={handleUpload}
                                                                isDisabled={!selectedFile}
                                                                isLoading={isUploading}
                                                        >
                                                                {uploadLabel}
                                                        </Button>
                                                )}
                                        </Flex>
                                </ModalFooter>
                        </ModalContent>
                </Modal>
        );
};

export default FileManagerModal;
